import React, { useEffect, useState } from "react";
import SlidePanel from "Components/SlidePanel/SlidePanel";
import UnitList from "./UnitList";
import ExportCsvForm from "./ExportCsvForm";
import useTranslation from "../../../Hooks/useTranslation";
import UnitChannelList from "./UnitChannelList";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useBoxes } from "Contexts/BoxContext";

const ExportCsvUnitModal = (props) => {
  const {
    isOpen,
    onCancel,
    onExportData,
    setCurrentUnit,
    currentUnitTitle,
    unitsRequest,
    dontShowChangeUnitModal,
    currentUnitModel,
    setSelectedCsvChannels,
    selectedCsvChannels
  } = props;

  const { unitBoxes, modalStep } = useBoxes();

  const translation = useTranslation();

  const [step, setStep] = useState("selectUnit");

  const { data: units } = unitsRequest;

  useEffect(() => {
    if (!isOpen) return;
    if (unitBoxes[0]?.type === "chartView" || unitBoxes[0]?.type === "digitalView" || unitBoxes[0]?.type === "dataTable" || currentUnitModel) {
      setStep("selectChannels");
    } else if (currentUnitTitle && !dontShowChangeUnitModal) {
      setStep("selectChannels");
    }
    if(modalStep === "exportCsv") {
      setStep("exportCsv")
    }
  }, [isOpen, currentUnitTitle, dontShowChangeUnitModal, modalStep, unitBoxes, currentUnitModel]);

  const handleSaveUnit = (unitId) => {
    setStep("selectChannels");
    setCurrentUnit(unitId);
  };

  const handleSaveChannels = () => {
    setStep("exportCsv");
  };

  const onModalCsvCancel = () => {
    onCancel();
    setStep('');
  };

  const onExportCsvData = (data) => {
    onCancel();
    setStep('');
    onExportData(data);
  };

  const renderBackToUnitButton = () => {
    if (step === "selectUnit" || step === '') return null;
    return (
      <IconButton
        aria-label="back"
        size="small"
        onClick={() => {
          if (step === "selectChannels") setStep("selectUnit");
          if (step === "exportCsv") setStep("selectChannels");
        }}
      >
        <ArrowBackIcon fontSize="inherit" />
      </IconButton>
    );
  };

  const renderTitle = () => {
    switch (step) {
      case "selectUnit":
        return translation.headerUnitsLabel || "Units";
      case "selectChannels":
        return translation.dashboardManageChannelsLabel;
      case "exportCsv":
        return translation.exportToCsvModalExportToCsvLabel;
      default:
        return "";
    }
  };

  const renderUnitList = () => {
    if (step !== "selectUnit") return null;

    return (
      <UnitList items={units} onCancel={onCancel} onSave={handleSaveUnit} />
    );
  };

  const renderChannelsList = () => {
    if (step !== "selectChannels") return null;

    return (
      <UnitChannelList
        unit={currentUnitModel}
        onCancel={onCancel}
        onSave={handleSaveChannels}
        unitsRequest={unitsRequest}
        setSelectedCsvChannels={setSelectedCsvChannels}
        isNotVisible = {step === "selectChannels"}
        selectedCsvChannels={selectedCsvChannels}
      />
    );
  };

  const renderCsvForm = () => {
    if (step !== "exportCsv") return null;

    return (
      <ExportCsvForm
        unit={currentUnitModel}
        onExportData={onExportCsvData}
        unitName={currentUnitTitle}
        onCancel={onModalCsvCancel}
        setStep={setStep}
      />
    );
  };

  const backButton = renderBackToUnitButton();

  return (
    <SlidePanel
      open={isOpen}
      onClose={onModalCsvCancel}
      title={renderTitle()}
      headerStart={backButton ? <div className="backLinkHolder">{backButton}</div> : null}
      className={step === "selectUnit" ? "appSlidePanel--wide" : ""}
    >
      {renderUnitList()}
      {renderChannelsList()}
      {renderCsvForm()}
    </SlidePanel>
  );
};

export default ExportCsvUnitModal;
